<template>
  <div>
    <p class="error">{{ error }}</p>
    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
      <button @click="$router.back()" class="close-button">
        <img src="@/assets/picto_close_qrcode.png"/>
      </button>
    </qrcode-stream>
  </div>
</template>

<script>
export default {
  data () {
    return {
      result: '',
      error: '',
      camera: 'auto',
      link: '',
      tab: []
    }
  },
  methods: {
    /**
     * Scan camera to check if there is a QR Code
     */
    onDecode (content) {
      this.result = content
      if(this.result != '') {
        this.turnCameraOff()
        // URL parser
        let tmp = this.result.split('/theme/')
        tmp.shift()
        tmp.unshift('/theme')
        this.link = tmp.join('/')
        let cpy = this.link
        this.tab = cpy.split('/')
        this.setModal()
      }
    },

    /**
     * Setup popup for scanning and display it
     */
    setModal() {
      let obj = {
        message: this.getDescription(),
        customIconUrl: 'https://i.imgur.com/c9eEiEuh.jpg',
        disableOverlayClick: true,
        useConfirmBtn: true,
        customConfirmBtnText: 'Y Aller',
        customCloseBtnText: 'Fermer',
        onConfirm: this.toStep,
        onClose: this.reload,
      }
      this.$Simplert.open(obj)
    },

    getId(n) {
      return this.tab[n]
    },

    getDescription() {
      let id = this.getId(6)
      let idt = this.getId(2)
      let d = []
      d[0] = this.$store.state.lesson.theme.byId[idt].title
      d[1] = this.$store.state.lesson.lesson.byId[id].title
      return d.join(' : ')
    },

    getTitle() {
      let idt = this.getId(2)
      return this.$store.state.lesson.theme.byId[idt].title
    },

    toStep() {
      this.$Simplert.close()
      this.$router.push({path: this.link})
    },

    /**
     * Reload camera
     */
    reload() {
      this.$Simplert.close()
      this.turnCameraOn()
    },

    turnCameraOn() {
      this.camera = 'auto'
    },

    turnCameraOff() {
      this.camera = 'off'
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.close-button {
  border: none;
  outline: none;
  background: none;
  position: absolute;
  right: 4px;
  top: 2px;
}
.close-button img {
  width: 35px;
}
</style>